import constants from './constants';
import api from './api';
import {createAsyncAction} from '../../utils/thunk_utils';

export const setTimeProposalMode = (flag) => ({
  type: constants.SET_TIME_PROPOSAL_MODE,
  data: flag
});

export const getPickupData = (id) => (dispatch) => {
  dispatch(createAsyncAction(
      constants.GET_PICKUP_DATA,
      api.getPickupData
  )(id));
};

export const sendPickupData = (data) => (dispatch) => {
  dispatch(createAsyncAction(
      constants.SEND_PICKUP_DATA,
      api.sendPickupData
  )(data));
};

export const proposeNewTime = (data) => (dispatch) => {
  dispatch(createAsyncAction(
    constants.PROPOSE_NEW_TIME,
    api.proposeNewTime
  )(data));
};

export const toggleSuccessMessage = (flag) => ({
  type: constants.TOGGLE_SUCCESS_MESSAGE,
  data: flag
});